// src/util/extractNumericDataAttribute.ts
var extractNumericDataAttribute = function extractNumericDataAttribute(event, name) {
  var value = parseInt(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  event.currentTarget.getAttribute("data-".concat(name)), 10);
  if (value === null || value === void 0 || Number.isNaN(value)) {
    return null;
  }
  return value;
};
export { extractNumericDataAttribute };